/**
 *
 * AreasPicker
 *
 */
import { httpClient } from 'api/HttpClient';
import { Condition, ODataFilterBuilder } from 'api/odata/ODataFilter';
import {
  AutocompletePicker,
  AutocompletePickerProps,
} from 'app/components/BasicPickers/AutocompletePicker';
import * as React from 'react';
import { Entity } from 'types/common';

export interface AreasPickerProps
  extends Omit<AutocompletePickerProps<Entity<number>>, 'loadData'> {}

const url = '/api/odata/v4/AreasFilter';
export const initAreasData = (initval: string | undefined) => {
  if (initval === undefined) {
    return new Promise<Entity<number>[]>((resolve, reject) => {
      resolve([] as Entity<number>[]);
    });
  } else {
    const id = parseInt(initval);
    const params: {
      $orderby: string;
      $filter?: string;
      $select: string;
      $top: number;
      $skip: number;
    } = {
      $orderby: 'Name asc',
      $filter: '(Id eq ' + id + ')',
      $select: 'Id,Name',
      $skip: 0,
      $top: 1,
    };
    return httpClient
      .get(url, params)
      .then(response => response.value as Entity<number>[]);
  }
};
const loadData = (
  searchTerm: string | null,
  predicates?: (string | Condition<any>)[],
) => {
  const params: { $orderby: string; $filter?: string } = {
    $orderby: 'Name asc',
  };
  if (searchTerm !== null || predicates !== undefined) {
    params.$filter = new ODataFilterBuilder<Entity<number>>({
      predicates: predicates !== undefined ? predicates : [],
      stringColumns: ['Name'],
      stringSearch: searchTerm !== null ? searchTerm : undefined,
    }).toString();
  }

  return httpClient
    .get(url, params)
    .then(response => response.value as Entity<number>[]);
};

export function AreasPicker(props: AreasPickerProps) {
  return (
    <AutocompletePicker
      size={props.size}
      loadData={loadData}
      {...props}
      id={props.id || 'AreasId'}
    />
  );
}
